@if(view.newsletters && view.newsletters.content.length > 0) {
<section class="w-full bg-gray-100 p-6">
    <div class="w-full mx-auto">
        <h1 class="text-3xl font-bold text-center text-gray-800">Welcome to Our Media Center</h1>
        <p class="text-lg text-center text-gray-600 mt-2 italic">Inspire Wanderlust with Every Click</p>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
            @for (newsletterItem of view.newsletters.content; track newsletterItem) {
            <fuse-card class="relative bg-white rounded-lg shadow-md overflow-hidden flex flex-col justify-between">

                @if (newsletterItem.createdOn) {
                <span class="absolute top-3 left-3 bg-accent text-white text-xs font-semibold px-3 py-1 rounded-full">
                    {{ newsletterItem.createdOn | date: 'd MMM' }}
                </span>
                }

                <img [src]="newsletterItem.imageUrlRaw" alt="Blog Image" class="w-full h-64 object-cover object-center">

                <div class="p-5 flex flex-col flex-grow justify-between">
                    <div>
                        <div class="flex justify-between text-sm text-gray-500 mb-2">
                            @if(newsletterItem.author) {
                            <span>✍️ {{ newsletterItem.author }}</span>
                            }
                            @if(parseMetaData(newsletterItem.metaData)?.dateMonth && parseMetaData(newsletterItem.metaData)?.dateDay && parseMetaData(newsletterItem.metaData)?.dateYear) {
                            <span>📅 {{ parseMetaData(newsletterItem.metaData)?.dateMonth }} {{ parseMetaData(newsletterItem.metaData)?.dateDay }}, {{ parseMetaData(newsletterItem.metaData)?.dateYear }}</span>
                            }
                        </div>
                        <h3 class="text-lg font-semibold text-gray-900 mb-2">{{ newsletterItem.name }}</h3>
                        <p class="text-md text-gray-600 mb-4" [innerHTML]="newsletterItem.rawContent"></p>
                    </div>

                    <div class="flex justify-end mt-auto">
                        @if(parseMetaData(newsletterItem.metaData)?.newsLink){
                            <a [href]="parseMetaData(newsletterItem.metaData)?.newsLink" target="_blank" rel="noopener noreferrer">
                                <button type="button"
                                    class="text-sm rounded-md uppercase font-semibold px-4 py-2 border-accent-500 bg-accent-500 text-primary-100 tracking-wide cursor-pointer sm:w-auto sm:flex-shrink-0 hover:text-primary-500 hover:bg-primary-100 transition ease-out duration-500">
                                    View More →
                                </button>
                            </a>
                        }
                    </div>
                </div>

            </fuse-card>
            }
        </div>

    </div>

</section>
}